import type { StrapiPrimitiveButton } from "@/types/strapi";

import type { ButtonVariantKeys } from "@/tokens/configs/button_config";

export function mapButtonAppearance(
    input: StrapiPrimitiveButton["Appearance"],
): ButtonVariantKeys | undefined {
    switch (input) {
        case "Primary":
            return "primary";
        case "Secondary":
            return "secondary";
        default:
            return undefined;
    }
}
